import useAgpCGM, { STATUS } from './useAgpCGM';

export { STATUS };

export default useAgpCGM;